"use client";

import { Timeline } from "@/components/ui/Timeline/Timeline";
import { motion } from "framer-motion";
import Image from "next/image";
import Skill from "../../ui/Skill";
import { HightLightText } from "@/components/ui/Text/HightLightText";

export default function Experience() {
  return (
    <div className="bg-white dark:bg-[#171420] mt-4 py-10 mb-20 relative">
      <div className="container color-home before:top-[1000px]">
        <div className="flex flex-col items-center relative">
          <motion.span
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.3, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="text-xl text-main-green font-medium"
          >
            Nói về
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7, delay: 0.4, ease: "easeInOut" }}
            viewport={{ once: true }}
            className="text-primary dark:text-[#45c3dc] text-4xl lg:text-5xl font-bold mb-16 mt-4 uppercase"
          >
            Kinh nghiệm
          </motion.h1>
          <div className="w-full mx-auto flex flex-col md:flex-row gap-x-10">
            <HightLightText className="text-main-dark dark:text-main-gray order-1 md:order-0">
              <motion.p
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="my-3 "
              >
                <span className="font-semibold text-primary dark:text-[#45c3dc]">
                  Kinh nghiệm:
                </span>{" "}
                Mình có gần 4 năm kinh nghiệm trong việc xây dựng và phát triển
                Websites và Web Application.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.3, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="mt-3 mb-1"
              >
                Mình đã từng làm việc với các công nghệ/ngôn ngữ như:
              </motion.p>
              <motion.ul
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.4, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="list-disc pl-6"
              >
                <li>
                  <span className="font-semibold">Frontend:</span> ReactJS,
                  NextJS.
                </li>
                <li>
                  <span className="font-semibold">Backend:</span> Laravel,
                  ExpressJS.
                </li>
                <li>
                  <span className="font-semibold">Stack:</span> Tailwinds,
                  CSS/SCSS, Typescript, Figma v.v
                </li>
                <li>
                  <span className="font-semibold">Database:</span> MongoDB,
                  MySQL.
                </li>
                <li>
                  <span className="font-semibold">CMS:</span> WordPress, ngoài
                  ra mình còn tự tạo CMS riêng bằng Laravel + Filament
                </li>
              </motion.ul>
              <motion.p
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.5, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="mt-3 mb-1"
              >
                Mình triển khai và quản trị hệ thống server bằng:
              </motion.p>
              <motion.ul
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.6, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="list-disc pl-6"
              >
                <li>
                  <span className="font-semibold">
                    Hệ điều hành và công cụ:
                  </span>{" "}
                  VPS, Hosting, Ubuntu, Nginx.
                </li>
                <li>
                  <span className="font-semibold">Cloud:</span> AWS (S3, EC2).
                </li>
                <li>
                  <span className="font-semibold">DevOps:</span> Docker.
                </li>
              </motion.ul>
              <motion.p
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.7, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="my-3"
              >
                Về ngoại ngữ, mình có khả năng đọc hiểu tài liệu và giao tiếp cơ
                bản trong công việc bằng tiếng Anh.
              </motion.p>
              <motion.p
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.8, ease: "easeInOut" }}
                viewport={{ once: true }}
                className="mb-4"
              >
                <span className="font-semibold text-primary dark:text-[#45c3dc]">
                  Học vấn:
                </span>{" "}
                Mình hoàn thành chương trình đại học khoá 2018 ~ 2022 tại
              </motion.p>
              <motion.div
                initial={{ opacity: 0, y: -100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.7, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Image
                  alt="School"
                  src="/images/school.svg"
                  width={0}
                  height={0}
                  sizes="100vw"
                  className="w-auto h-auto mx-auto"
                />
              </motion.div>
            </HightLightText>
            <motion.div
              initial={{ opacity: 0, y: -100 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2 flex justify-center self-center order-0 md:order-1 bg-avatar"
            >
              <Image
                alt="Avatar"
                src="/images/avatar/avatar.png"
                width={550}
                height={490}
                sizes="auto"
              />
              <div className="icon-1">
                <Image
                  alt="Icon chạy lung tung"
                  src="/icons/icon-bg-1.svg"
                  width={22}
                  height={22}
                />
              </div>
              <div className="icon-2">
                <Image
                  alt="Icon nhân lên xuống"
                  src="/icons/icon-bg-2.svg"
                  width={27}
                  height={26}
                />
              </div>
              <div className="icon-3">
                <Image
                  alt="Icon tròn lên xuống"
                  src="/icons/icon-bg-3.svg"
                  width={27}
                  height={26}
                />
              </div>
              <div className="icon-4">
                <Image
                  alt="Icon tròn lên xuống"
                  src="/icons/icon-bg-4.svg"
                  width={34}
                  className="w-auto h-auto"
                  height={35}
                />
              </div>
            </motion.div>
          </div>
          <Timeline />
          <Skill />
        </div>
      </div>
    </div>
  );
}
